import { useTunnelFanNamesLazyQuery } from '@kinetic-ui/data-layer';
import { DataSource, FormOption } from '@qfa/forms';
import { getNodes } from 'kineticUtils';
import { useCallback } from 'react';

export const useTunnelFanNamesDataSource = (): DataSource<FormOption[]> => {
  const [getFanNames] = useTunnelFanNamesLazyQuery();

  const load = useCallback(async () => {
    const { data } = await getFanNames();
    const fanOptions = getNodes(data?.tunnelFans).map((fan) => ({
      label: fan.name,
      value: fan.id,
    }));

    return fanOptions as FormOption[];
  }, [getFanNames]);

  return { load };
};
